import { useLocation } from 'react-router-dom';

const useEliteStatus = () => {
  const location = useLocation();
  const isElite = location.pathname === '/oferta-elite';

  return isElite;
};

export default useEliteStatus;